import "./UserRequests.css";
import React, { Fragment } from "react";
import UserRequestsViewModel from "./UserRequestsViewModel";
import { PulseLoader } from "react-spinners";
import { Link } from "react-router-dom";
import NoDataFound from "../../../Components/NoDataFound/NoDataFound";
import ActionConfirmation from "../../../Components/ActionConfirmation/ActionConfirmation";
import { ToastContainer } from "react-toastify";

const UserRequests = () => {
  const {
    AllUserRequests,
    IsLoading,
    navigate,
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
  } = UserRequestsViewModel();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper user-requests-listing-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">User Requests</h3>
                {/* <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">User Requests</li>
                </ul> */}
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="student-group-form">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Name ..."
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Email ..."
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by School Type ..."
                  />
                </div>
              </div>
              <div className="col-lg-2">
                <div className="search-student-btn">
                  <button type="btn" className="btn btn-primary">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">User Requests</h3>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>School Type</th>
                            <th>School Level</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {AllUserRequests &&
                            AllUserRequests.map((item, index) => {
                              const ArrayOfNameWords = item?.Name.split(" ");
                              for (
                                var i = 0;
                                i < ArrayOfNameWords.length;
                                i++
                              ) {
                                ArrayOfNameWords[i] =
                                  ArrayOfNameWords[i].charAt(0).toUpperCase() +
                                  ArrayOfNameWords[i].slice(1);
                              }
                              const StringOfNameWords =
                                ArrayOfNameWords.join(" ");
                              return (
                                <tr
                                  onClick={() => {
                                    navigate(
                                      `/user/super-admin/requests/${item?.id}`
                                    );
                                  }}
                                  key={index}
                                >
                                  <td>{StringOfNameWords}</td>
                                  <td>{item?.Email}</td>
                                  <td>{item?.PhoneNo}</td>
                                  <td>{item?.SchoolType}</td>
                                  <td>{item?.SchoolLevel}</td>

                                  <td className="text-end">
                                    <div className="actions ">
                                      <Link
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleOpenDeleteDialog(item?.id);
                                        }}
                                        className="btn btn-sm bg-success-light me-2 "
                                      >
                                        <i className="fa-regular fa-trash-can"></i>
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      {AllUserRequests?.length <= 0 && <NoDataFound />}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}

      <ActionConfirmation
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this request?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />

      <ToastContainer />
    </Fragment>
  );
};

export default UserRequests;
